import { render, staticRenderFns } from "./ActivityHeader.vue?vue&type=template&id=7f573ff8&scoped=true"
import script from "./ActivityHeader.vue?vue&type=script&lang=ts"
export * from "./ActivityHeader.vue?vue&type=script&lang=ts"
import style0 from "./ActivityHeader.vue?vue&type=style&index=0&id=7f573ff8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f573ff8",
  null
  
)

export default component.exports